const ActionType = (actionType) => `APPLICATION_${actionType}`;

export const SETUP = ActionType('SETUP');
export const APP_LAUNCH = ActionType('APP_LAUNCH');
export const APP_LAUNCH_TRACK = ActionType('APP_LAUNCH_TRACK');
export const BOOTSTRAP_REQUEST = ActionType('BOOTSTRAP_REQUEST');
export const BOOTSTRAP_RESTART_REQUEST = ActionType('BOOTSTRAP_RESTART_REQUEST');
export const BOOTSTRAP_LOADED = ActionType('BOOTSTRAP_LOADED');
export const APP_LOADED = ActionType('APP_LOADED');
export const UNDEFINED_ERROR = ActionType('UNDEFINED_ERROR');
export const SET_LAUNCH_STATE = ActionType('SET_LAUNCH_STATE');
export const SET_APP_INFO = ActionType('SET_APP_INFO');
export const SET_SESSION_TOKEN = ActionType('SET_SESSION_TOKEN');
export const SESSION_TOKEN_REFRESHED = ActionType('SESSION_TOKEN_REFRESHED');
export const FEATURE_DISCOVERY = ActionType('FEATURE_DISCOVERY');
export const SET_FOCUSED_AREA = ActionType('SET_FOCUSED_AREA');
export const POLICY_ACCEPTED = ActionType('POLICY_ACCEPTED');
export const POLICY_VIEWED = ActionType('POLICY_VIEWED');
export const POLICY_VIEWED_ACCEPTED = ActionType('POLICY_VIEWED_ACCEPTED');
export const DISMISS_GET_APP_BANNER = ActionType('DISMISS_GET_APP_BANNER');
export const BUFFER_EVENTS = ActionType('BUFFER_EVENTS');
export const LINK_CLICK = ActionType('LINK_CLICK');
